import { createFileRoute } from "@tanstack/react-router";

import ConnectionsPage from "@/features/dashboard/pages/connections";

export const Route = createFileRoute("/(app)/ops/connections/")({
  component: () => <ConnectionsPage />,
});
